/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetServerScopePinRequestBody = {
  /**
   * The ID of the remote-backed MCP server.
   */
  mcpServerId: string;
  /**
   * Scopes to pin on the server's protected resource, shared by servers with the same upstream URL, in request order. Whitespace is trimmed, blanks and duplicates are dropped, and at most 100 scopes may remain; an empty list clears the pin.
   */
  scopes: Array<string>;
};

/** @internal */
export type SetServerScopePinRequestBody$Outbound = {
  mcp_server_id: string;
  scopes: Array<string>;
};

/** @internal */
export const SetServerScopePinRequestBody$outboundSchema: z.ZodMiniType<
  SetServerScopePinRequestBody$Outbound,
  SetServerScopePinRequestBody
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
    scopes: z.array(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function setServerScopePinRequestBodyToJSON(
  setServerScopePinRequestBody: SetServerScopePinRequestBody,
): string {
  return JSON.stringify(
    SetServerScopePinRequestBody$outboundSchema.parse(
      setServerScopePinRequestBody,
    ),
  );
}
